<template>
    <div class="vue-partspoint-finder partspoint-finder" :class="{'is-homepage': isHomePage, 'map-active': isMobile && showMap, 'list-active': isMobile && !showMap }">
        <div class="finder-wrapper">
            <div class="search-bar-wrapper">
                <div class="row">
                    <div class="search-bar col-12 col-md-6 col-xl-5">
                        <div class="inner">
                            <h1 class="virtual-h2 mb-3 title" v-if="!isHomePage">
                                {{ findABranchText }}
                            </h1>

                            <h2 class="mb-3 title" v-if="isHomePage">
                                {{ findABranchText }}
                            </h2>

                            <div class="finder-search-input">
                                <div class="input-group finder-input">
                                    <gmap-autocomplete
                                        ref="gmapAutocomplete"
                                        class="vue-gmap-autocomplete form-control"
                                        :placeholder="finderPlaceholder"
                                        :select-first-on-enter="true"
                                        :options="autocompleteOptions"
                                        @focus="loadMap"
                                        @place_changed="setPlace">
                                    </gmap-autocomplete>

                                    <button
                                        v-if="showResetButton"
                                        @click="handleReset"
                                        class="reset-map"
                                    ><span class="visually-hidden">{{ resetMapText }}</span></button>
                                </div>
                            </div>

                            <template v-if="isMobile">
                                <ul class="mobile-toggle">
                                    <li><button :class="{'active': !showMap}" @click="showMap = false">{{ listViewText }}</button></li>
                                    <li><button :class="{'active': showMap}" @click="showMap = true">{{ mapViewText }}</button></li>
                                </ul>
                            </template>

                            <template v-if="hasMarkers && !loading">
                                <perfect-scrollbar>
                                    <div class="marker-meta">
                                        <p>{{ markersLength }} {{ branchesText }} <template v-if="hasPlace">{{ branchesNearText }}</template></p>
                                    </div>

                                    <div class="results-wrapper" v-if="showList">
                                        <pp-marker-mini-card
                                            v-for="(marker, index) in computedMarkers"
                                            :key="index"
                                            :marker="marker"
                                            :event-bus="eventBus"
                                            :is-home-page="isHomePage"
                                            @marker-clicked="handleMarkerClicked"
                                            @active-marker="handleActiveMarker"
                                        ></pp-marker-mini-card>
                                    </div>
                                </perfect-scrollbar>
                            </template>

                            <template v-if="loading">
                                <div class="loader"><span class="visually-hidden">{{ loadingText }}</span></div>
                            </template>

                            <transition name="fade" v-if="!isMobile">
                                <pp-active-marker
                                    v-if="hasActiveMarker"
                                    :marker="activeMarker"
                                    :event-bus="eventBus"
                                ></pp-active-marker>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="doMapLoad === true">
                <div class="store-locator" v-show="showMap">
                    <GmapMap
                        :center="center"
                        ref="mapRef"
                        :zoom="mapZoom"
                        map-type-id="roadmap"
                        :options="mapOptions"
                        @zoom_changed="mapZoom = $event"
                    >
                        <gmap-custom-marker
                            v-for="(marker, index) in markers"
                            :marker="{lat: marker.geoLocation.lat, lng: marker.geoLocation.lng}"
                            :key="index"
                            class="gmap-custom-marker"
                            :class="activeMarker === marker ? 'active' : 'inactive'"
                        >
                            <pp-marker-wrapper
                                :marker="marker"
                                :event-bus="eventBus"
                                :is-home-page="isHomePage"
                                :active-marker="activeMarker"
                                @marker-clicked="handleMarkerClicked"
                                @active-marker="handleActiveMarker"
                            ></pp-marker-wrapper>
                        </gmap-custom-marker>
                    </GmapMap>
                </div>
            </template>

            <pp-google-inside-wrapper
                :event-bus="eventBus"
            ></pp-google-inside-wrapper>

            <transition name="fade" v-if="isMobile">
                <pp-active-marker
                    v-if="hasActiveMarker"
                    :marker="activeMarker"
                    :event-bus="eventBus"
                ></pp-active-marker>
            </transition>
        </div>

        <div class="section-body-text" v-if="hasActiveMarker && isHomePage === false">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8" v-html="activeMarker.body">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mixin as focusMixin} from './../../../../../themes/custom/ef2_custom/node_modules/vue-focus';
import GmapCustomMarker from './../../../../../themes/custom/ef2_custom/node_modules/vue2-gmap-custom-marker';
import MarkerWrapper from '../../../../../modules/custom/partspoint_base/js/components/MarkerWrapper';
import MapSidebar from '../../../../../modules/custom/partspoint_base/js/components/MapSidebar';
import GoogleInsideWrapper from '../../../../../modules/custom/partspoint_base/js/components/GoogleInsideWrapper';
import MarkerMiniCard from "./MarkerMiniCard";
import ActiveMarker from "./ActiveMarker";
import translations from "../../../../../themes/custom/ef2_custom/js/vue/mixins/translations";

export default {
    name: "PartsPointFinder",

    mixins: [focusMixin, translations],

    components: {
        'gmap-custom-marker': GmapCustomMarker,
        'pp-marker-wrapper': MarkerWrapper,
        'pp-map-sidebar': MapSidebar,
        'pp-google-inside-wrapper': GoogleInsideWrapper,
        'pp-marker-mini-card': MarkerMiniCard,
        'pp-active-marker': ActiveMarker,
    },

    props: {
        bundle: {
            type: String,
            default: ""
        },
        activeGarageId: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            eventBus: new Vue(),
            markers: [],
            doMapLoad: false,
            showMap: true,

            activeMarker: {},

            mapOptions: {
                streetViewControl: false,
                fullscreenControl: false,

                styles: [
                    {
                        "featureType": "all",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#000000"
                            },
                            {
                                "lightness": 13
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#7a7a7a"
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#144b53"
                            },
                            {
                                "lightness": 14
                            },
                            {
                                "weight": 1.4
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#7a7a7a"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.country",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#316E8C"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#082233"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#0c4152"
                            },
                            {
                                "lightness": 5
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#000000"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#0c191c"
                            },
                            {
                                "lightness": 25
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#000000"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#0b3d51"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#000000"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#146474"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#021019"
                            }
                        ]
                    }
                ]
            },

            place: null,
            center: {lat: 52.078663, lng: 4.288788},
            mapZoom: 7,

            autocompleteOptions: {
                types: ['geocode'],
                componentRestrictions: {
                    country: ['nl']
                }
            },

            filteredMarkers: {},
            gmapInputValue: '',
            loading: false,
        }
    },

    mounted() {
        this.checkDevice();
        this.fetchData();
        setTimeout(() => this.doMapLoad = true, 1000);
        this.eventBus.$on('remove-active-marker', () => this.handleRemoveActiveMarker());
    },

    computed: {
        device() {
            return this.$mq;
        },

        isMobile() {
            return this.device === 'mobile';
        },

        showList() {
            if (!this.isMobile) {
                return true;
            }

            return !this.showMap;
        },

        hasActiveMarker() {
            return !_.isEmpty(this.activeMarker);
        },

        isHomePage() {
            return _.isEqual(this.bundle, 'homepage');
        },

        hasMarkers() {
            return ! _.isEmpty(this.markers)
        },

        hasPlace() {
            return ! _.isNil(this.place);
        },

        markersLength() {
            return Object.keys(this.computedMarkers).length;
        },

        showFilteredMarkers() {
            return !_.isEmpty(this.filteredMarkers) && this.hasPlace && !this.loading;
        },

        noFilteredMarkersResult() {
            return _.isEmpty(this.filteredMarkers) && !_.isEmpty(this.gmapInputValue) && !this.loading;
        },

        showResetButton() {
            return ! _.isEmpty(this.gmapInputValue) && !this.loading;
        },

        computedMarkers() {
            if (this.showFilteredMarkers) {
                return this.filteredMarkers;
            }

            return this.markers;
        },
    },

    methods: {
        fetchData(fromPlace = false) {
            this.loading = true;
            let url = `/api/garages`;

            if (fromPlace) {
                url = url.concat(`?lat=${this.place.geometry.location.lat()}&lng=${this.place.geometry.location.lng()}`);
            }

            axios.get(url)
                .then(response => {
                    if (!fromPlace) {
                        this.markers = response.data;
                        return;
                    }

                    this.filteredMarkers = response.data;
                })
                .catch(error => {
                    this.markers = {};
                    this.filteredMarkers = {};
                })
                .finally(() => {
                    if (!fromPlace) {
                        this.checkActiveGarageId();
                    }

                    this.loading = false;
                });
        },

        loadMap() {
            setTimeout(this.doMapLoad = true, 500);
        },

        setPlace(place) {
            if (_.isEmpty(place.name)) {
                this.handleReset();
                return;
            }

            this.place = place;
            this.goToPlace();
            this.gmapInputValue = this.$refs.gmapAutocomplete.$refs.input.value;
            this.fetchData(true);
        },

        checkBundleType() {
            if (this.bundle !== "garages_overview") {
                this.doMapLoad = false;
                return;
            }

            this.doMapLoad = true;
        },

        goToPlace() {
            if (!this.place || _.isNil(this.place.geometry)) {
                // this.$toaster.error('Er is geen locatie gevonden. ')
                return;
            }

            this.center = {
                lat: this.place.geometry.location.lat(),
                lng: this.place.geometry.location.lng(),
            };

            this.mapZoom = 11;
        },

        geoLocate() {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                this.mapZoom = 11;

                // Mag uit voor prod
                // this.$toaster.success('Locatie succesvol opgehaald!')
            });
        },

        handleMarkerClicked(payload) {
            this.mapZoom = 11;
            this.$refs.mapRef.panTo({lat: parseFloat(payload.lat), lng: parseFloat(payload.lng)})
        },

        handleActiveMarker(payload) {
            if (_.isEmpty(payload)) {
                this.mapZoom = 7;
                this.$refs.mapRef.panTo(this.center);
            }

            this.activeMarker = payload;
        },

        handleRemoveActiveMarker() {
            this.activeMarker = {};
            let zoom = 8;

            if (!_.isEmpty(this.gmapInputValue)) {
                zoom = 11;
            }

            this.mapZoom = zoom;
            this.$refs.mapRef.panTo(this.center);
            this.changePageMeta();
        },

        checkActiveGarageId() {
            let initialActiveMarker = _.find(this.markers, (marker) => {
                return marker.id === parseFloat(this.activeGarageId);
            });

            if (_.isNil(initialActiveMarker)) {
                return;
            }

            this.activeMarker = initialActiveMarker;

            setTimeout(() => {
                this.mapZoom = 11;
                this.$refs.mapRef.panTo({
                    lat: parseFloat(this.activeMarker.geoLocation.lat),
                    lng: parseFloat(this.activeMarker.geoLocation.lng)
                })
            }, 1000);
        },

        changePageMeta() {
            if (this.isHomePage) {
                return;
            }

            let newPageTitle = newPageTitleText;
            document.title = newPageTitle;
            window.history.pushState({}, newPageTitle, window.location.origin + '/vestigingen');
        },

        handleReset() {
            this.filteredMarkers = {};
            this.place = null;
            this.gmapInputValue = '';
            this.$refs.gmapAutocomplete.$refs.input.value = '';
            this.mapZoom = 7;
            this.center = {lat: 52.078663, lng: 4.288788};
            this.$refs.mapRef.panTo(this.center);
        },

        checkDevice() {
            if (this.device !== 'mobile') {
                return;
            }

            this.showMap = false;
        }
    }
}
</script>
